import {Button, Divider, List, Popover} from '@material-ui/core';
import {ListItemLink} from 'components';
import {useGetPortalOrgs} from 'hooks/useGetEndpoint';
import {useState} from 'react';

const OrgPopover = ({
    open,
    id,
    anchorEl,
    onClose,
    anchorOrigin = {
        vertical: 'center',
        horizontal: 'right',
    },
    transformOrigin = {
        vertical: 'center',
        horizontal: 'left',
    },
    handleClose = () => {},
    myOrgs,
}) => {
    const {data} = useGetPortalOrgs();
    const allOrgs = data?.organizations;
    const orgs = myOrgs || allOrgs;

    return (
        <Popover
            open={open}
            id={id}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={anchorOrigin}
            transformOrigin={transformOrigin}
        >
            <List>
                {!myOrgs
                    ? [
                          <ListItemLink
                              key='all-users'
                              primary='All MM-SEAS Users'
                              to='/portal/all'
                              onClick={handleClose}
                          />,
                          <Divider key='all-users-divider' />,
                      ]
                    : null}
                {orgs?.map(org => (
                    <ListItemLink
                        key={`org-${org.id}`}
                        primary={org?.name}
                        to={`/portal/${org?.id}`}
                        onClick={handleClose}
                    />
                ))}
            </List>
        </Popover>
    );
};

const OrgPopoverButton = ({buttonText, ...buttonProps}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const id = open ? 'org-popover' : undefined;
    const handleClick = e => {
        setAnchorEl(e.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return [
        <Button key='button' {...buttonProps} onClick={handleClick}>
            {buttonText}
        </Button>,
        <OrgPopover
            key='org-popover'
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
        />,
    ];
};

export default OrgPopover;
export {OrgPopover, OrgPopoverButton};
